import * as React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import { DateInputContainer, Form, FormRow } from 'components/inputs'
import Button from '../../../../../components/Button'
import { UpdateDeadlineDialogViewModel } from './UpdateDeadlineDialogViewModel'
import styles from './UpdateDeadlineDialog.sass'

interface UpdatedDeadlineDialogProps {
  vm: UpdateDeadlineDialogViewModel
}

export default observer(({ vm }: UpdatedDeadlineDialogProps) => (
  <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
    <ModalSheetHeader withCloseButton />

    <ModalSheetContent>
      <ModalSheetContentBlock>
        <ModalSheetContentTitle>Update Deadline</ModalSheetContentTitle>

        <ModalSheetContentDescription>
          Set new date and time for job completion
        </ModalSheetContentDescription>
      </ModalSheetContentBlock>

      <ModalSheetContentBlock>
        <Form>
          <FormRow>
            <div className="update-deadline-container">
              <DateInputContainer
                calendarClassName={styles.deadlineCalendar}
                dataTest={'deadline-calendar-field'}
                model={vm}
                clearIcon={false}
                field="deadline"
                label="Deadline"
                format="MM/dd/yyyy h:mm a"
                includeTime
                icon="dropdown"
                minDate={new Date()}
              />
            </div>
          </FormRow>
        </Form>
      </ModalSheetContentBlock>
    </ModalSheetContent>

    <ModalSheetFooter>
      <ModalSheetFooterSpacer />
      <ModalSheetFooterButtonGroup>
        <Button
          type="default"
          onClick={vm.close}
          data-test="update-deadline-close-button"
        >
          Close
        </Button>
        <Button
          type="primary"
          data-test="update-deadline-submit-button"
          onClick={vm.update}
        >
          Update
        </Button>
      </ModalSheetFooterButtonGroup>
    </ModalSheetFooter>
  </ModalSheet>
))
